















import { Prop, Component, Vue } from 'vue-property-decorator';

@Component
export default class BatteryLevel extends Vue {
  @Prop()
  public level!: number;

  public levelClasses = [
    { range: [0, 20], color: 'red' },
    { range: [20, 50], color: 'orange' },
    { range: [50, 80], color: '#b9cf00' },
    { color: 'green' },
  ];

  public get isLevelValid(): boolean {
    return (
      typeof this.level === 'number' && this.level >= 0 && this.level <= 100
    );
  }

  public get colorForLevel(): string {
    const matchingClass = this.levelClasses.find((levelClass) =>
      this.isClassMatchingLevel(this.level, levelClass),
    );

    if (!matchingClass) {
      return 'lightgrey';
    }

    return matchingClass.color;
  }

  public isClassMatchingLevel(level: number, levelClass: any): boolean {
    if (!levelClass.range) {
      return true;
    }

    return level >= levelClass.range[0] && level < levelClass.range[1];
  }
}
